// to reduce cognitive complexity of the report.thunk.ts

import {
  setCapacitySelectedFloors,
  setCapacitySelectedLocations,
  setCapacitySelectedWorkplaceOrZone
} from "../slices/report.slice";
import { CapacityObject, CapacityPerformance } from "../typings/reports.types";
import { FetchReportParams } from "./report.thunk";

/** initial filter param is id, then when filter params exists, use filter */
export const initFilterParams = (params: FetchReportParams) => {
  // initial filter param is id
  const initialFilterParam = Array.isArray(params.id) ? params.id : [params.id];
  // when filter params exists, use filter
  const filterParams = params.filter ?? initialFilterParam;

  return filterParams;
};

export function dispatchDataByFilterType(
  dispatch: any,
  params: FetchReportParams,
  data: CapacityPerformance
) {
  if (params.filterType === "location") {
    dispatch(
      setCapacitySelectedLocations({
        id: params.id,
        capacity: data
      } as CapacityObject)
    );
  } else if (params.filterType === "floor") {
    dispatch(
      setCapacitySelectedFloors({
        id: params.id,
        capacity: data
      } as CapacityObject)
    );
  } else if (params.isAttFilterApplied?.applied) {
    dispatch(
      setCapacitySelectedFloors({
        id: params.isAttFilterApplied.floorInventoryId,
        capacity: data
      } as CapacityObject)
    );
  } else {
    dispatch(
      setCapacitySelectedWorkplaceOrZone({
        id: params.id,
        capacity: data
      } as CapacityObject)
    );
  }
}

export const arraysAreEqual = (a: number[], b: number[]): boolean => {
  if (a.length !== b.length) return false;
  return a.every((val, index) => val === b[index]);
};
